export default [
  // {
  //   title: 'sandoz.verifications_old',
  //   requiredPermissions: [
  //     'GET api/verifications/contracts',
  //     'POST api/verifications/deny',
  //     'POST api/verifications/allow',
  //     'POST api/verifications/delete-picture',
  //     'POST api/verifications/upload-picture',
  //     'GET api/verifications/contracts/{id}'
  //   ],
  //   target: 'verifications.verifications'
  // },
  {
    title: 'sandoz.verifications',
    requiredPermissions: [
      'GET api/verifications-new/contracts',
      'POST api/verifications/deny',
      'POST api/verifications/allow',
      'POST api/verifications/delete-picture',
      'POST api/verifications/upload-picture',
      'GET api/verifications-new/contracts/{id}'
    ],
    target: 'verifications.new_verifications'
  },
  {
    title: 'sandoz.contracts',
    requiredPermissions: [
      'GET api/contracts'
    ],
    target: 'contracts.list'
  },
  {
    title: 'sandoz.cp_customers',
    requiredPermissions: [
      'GET api/customers'
    ],
    target: 'customers.list'
  },
  {
    title: 'sandoz.cp_logins',
    requiredPermissions: [
      'GET api/customer-logins'
    ],
    target: 'customer_logins.list'
  }
]
